module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Medium-Italic.76fb1ae9.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Medium-Italic.woff
// module id = 2313
// module chunks = 50